var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.269,
    height: 49.269,
    viewBox: "0 0 49.269 49.269",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x31_6_Destination",
    transform: "translate(-0.141 -0.141)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_291",
    "data-name": "Group 291",
    transform: "translate(0.141 0.141)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M301.1,191.06a6.005,6.005,0,0,0-.936.8.786.786,0,1,0,1.142,1.081,4.455,4.455,0,0,1,.691-.594.786.786,0,0,0-.9-1.291Z",
    transform: "translate(-271.082 -172.551)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M341.78,181.342h-1.075a.786.786,0,1,0,0,1.572h1.075a.786.786,0,1,0,0-1.572Z",
    transform: "translate(-307.205 -163.896)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M338.417,288.891c-.8,0-.867,0-1.039,0a.778.778,0,0,0-.821.75.787.787,0,0,0,.75.821c.225.01.313,0,1.11.006a.786.786,0,1,0,0-1.572Z",
    transform: "translate(-304.166 -261.085)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M331.225,471.358H330.15a.786.786,0,0,0,0,1.573h1.075a.786.786,0,1,0,0-1.573Z",
    transform: "translate(-297.666 -425.988)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M241.912,471.358h-1.075a.786.786,0,0,0,0,1.573h1.075a.786.786,0,0,0,0-1.573Z",
    transform: "translate(-216.952 -425.988)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M286.046,230.548a.786.786,0,0,0,.785-.842,4.457,4.457,0,0,1,.028-.912.786.786,0,0,0-1.559-.21,6.026,6.026,0,0,0-.038,1.232A.786.786,0,0,0,286.046,230.548Z",
    transform: "translate(-257.796 -205.974)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M299.758,270.506a4.428,4.428,0,0,1-.653-.636.786.786,0,0,0-1.208,1.007,6.035,6.035,0,0,0,.884.862.786.786,0,0,0,.976-1.233Z",
    transform: "translate(-269.064 -243.645)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M286.569,471.358h-1.075a.786.786,0,0,0,0,1.573h1.075a.786.786,0,0,0,0-1.573Z",
    transform: "translate(-257.309 -425.988)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M424.291,303.488a.786.786,0,0,0-.85,1.323,8.013,8.013,0,0,1,.789.578.786.786,0,1,0,1-1.209A9.613,9.613,0,0,0,424.291,303.488Z",
    transform: "translate(-382.358 -274.168)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M454.957,338.007a.786.786,0,0,0,.429-1.026,9.494,9.494,0,0,0-.51-1.053.786.786,0,1,0-1.37.771,8.05,8.05,0,0,1,.425.879A.786.786,0,0,0,454.957,338.007Z",
    transform: "translate(-409.764 -303.236)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M465.407,378.155a.786.786,0,0,0-.77.8,8.158,8.158,0,0,1-.038.98.786.786,0,1,0,1.565.155,9.691,9.691,0,0,0,.045-1.166A.781.781,0,0,0,465.407,378.155Z",
    transform: "translate(-419.877 -341.759)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M418.124,454.862a7.976,7.976,0,0,1-.831.513.786.786,0,1,0,.742,1.386,9.56,9.56,0,0,0,1-.615.786.786,0,1,0-.907-1.284Z",
    transform: "translate(-376.754 -410.95)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M451.319,421.358a.787.787,0,0,0-1.057.347,7.945,7.945,0,0,1-.494.844.786.786,0,1,0,1.306.876,9.61,9.61,0,0,0,.592-1.01A.787.787,0,0,0,451.319,421.358Z",
    transform: "translate(-406.357 -380.726)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M383.208,289.393a9.558,9.558,0,0,0-1.159-.164.786.786,0,0,0-.125,1.567,8.024,8.024,0,0,1,.968.137.786.786,0,1,0,.316-1.54Z",
    transform: "translate(-344.511 -261.392)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M375.782,470.668a8.071,8.071,0,0,1-.976.061.786.786,0,0,0,0,1.572h0a9.628,9.628,0,0,0,1.167-.073.786.786,0,1,0-.194-1.561Z",
    transform: "translate(-338.023 -425.36)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M56.829,452.522c-.708,1.012-1.389,1.955-2,2.788a2.849,2.849,0,0,1-4.6,0c-.613-.833-1.295-1.777-2-2.788-2.107.561-3.5,1.515-3.5,2.6,0,1.719,3.491,3.113,7.8,3.113s7.8-1.394,7.8-3.113C60.325,454.037,58.936,453.083,56.829,452.522Z",
    transform: "translate(-40.434 -408.966)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M13.691,171.493c3.216-4.369,10.634-15.015,10.634-20.249a12.092,12.092,0,1,0-24.184,0c0,5.234,7.418,15.88,10.634,20.249a1.808,1.808,0,0,0,2.916,0ZM4.617,151.244a7.616,7.616,0,1,1,7.616,7.616A7.616,7.616,0,0,1,4.617,151.244Z",
    transform: "translate(-0.141 -125.768)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M405.118,174.4c-.424.608-.828,1.169-1.2,1.667a2.039,2.039,0,0,1-3.3,0c-.367-.5-.771-1.059-1.2-1.667-.9.309-1.457.77-1.457,1.284,0,.949,1.924,1.719,4.3,1.719s4.3-.771,4.3-1.719C406.575,175.167,406.014,174.706,405.118,174.4Z",
    transform: "translate(-359.67 -157.619)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M380.886,17.967c1.772-2.408,5.861-8.276,5.861-11.161a6.665,6.665,0,1,0-13.329,0c0,2.885,4.089,8.753,5.861,11.161A1,1,0,0,0,380.886,17.967Zm-5-11.161a4.2,4.2,0,1,1,4.2,4.2A4.2,4.2,0,0,1,375.885,6.806Z",
    transform: "translate(-337.478 -0.141)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDest);
export default __webpack_public_path__ + "static/media/dest.553bf660a4db4c06dd86d4336d5be0f7.svg";
export { ForwardRef as ReactComponent };